import WebApp from '@twa-dev/sdk';
export const useHapticFeedback = (impact = 'medium') => {
    WebApp.HapticFeedback.impactOccurred(impact);
};
